export function isAiffFile(file: File): boolean {
  const name = file.name.toLowerCase()
  return name.endsWith('.aif') || name.endsWith('.aiff')
}

// Placeholder: real AIFF->WAV conversion would be added if needed
export async function convertAiffToWav(arrayBuffer: ArrayBuffer): Promise<ArrayBuffer> {
  // For now we just return the original buffer; UI will warn that AIFF passthrough is experimental.
  return arrayBuffer
}
